import React from 'react';
import {ImageUploader} from '../uploaders';
import LayerData from './layer-data';
import './stage-editor.css';

/** @class ScrollLayerData
  * A component for editing scrolling layer-specific properties.
  * @prop {string} name - the layer's name
  * @prop {url} image - the image to display
  * @prop {string} direction - the direction for the layer to scroll
  * @prop {integer} speed - the speed at which to scroll
  */
export default class ScrollingLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Scrolling Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="direction">Direction</label><br/>
          <select name="direction"
            value={this.state.direction}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            >
            <option value="up">Up</option>
            <option value="down">Down</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
          </select>
        </div>
        <div className="input-group">
          <label htmlFor="name">Speed</label><br/>
          <input name="speed" type="number"
            value={this.state.speed}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <ImageUploader
            name="Scrolling Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={(url)=>this.handleImageUpload("image", url)}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/scrolling-layer-data.js